export const attSubQueryObjectMap = {
  att_all_active: {
    att_status: 'active',
  },
  att_active: {
    att_status: 'active',
    synced_with_att: true,
  },
  att_bypass_active: {
    att_status: 'active',
    synced_with_att: false,
  },
  att_suspended: {
    att_status: 'suspended',
    synced_with_att: true,
  },
  att_bypass_suspended: {
    att_status: 'suspended',
    synced_with_att: false,
  },
  att_expired: {
    att_status: 'expired',
  },
};

export const attMapCountToFilter = {
  all: ['all'],
  att_all_active: ['active', 'bypass_active'],
  att_active: ['active'],
  att_bypass_active: ['bypass_active'],
  att_suspended: ['suspended'],
  att_bypass_suspended: ['bypass_suspended'],
  att_expired: ['expired'],
};

export const attSubsRequestButtonName = {
  'Show all': 'all',
  'All Active': 'att_all_active',
  Active: 'att_active',
  'Bypass Active': 'att_bypass_active',
  Suspended: 'att_suspended',
  'Bypass Suspended': 'att_bypass_suspended',
  Expired: 'att_expired',
};

export const simoSubQueryObjectMap = {
  simo_active: {
    simo_status: 'active',
  },
  simo_suspended: {
    simo_status: 'suspended',
  },
  simo_expired: {
    simo_status: 'expired',
  },
};

export const simoMapCountToFilter = {
  all: ['all'],
  simo_active: ['active'],
  simo_suspended: ['suspended'],
  simo_expired: ['expired'],
};

export const simoSubsRequestButtonName = {
  'Show all': 'all',
  Active: 'simo_active',
  Suspended: 'simo_suspended',
  Expired: 'simo_expired',
};

export const tracfoneSubsRequestButtonName = {
  'Show all': 'all',
  Active: 'tracfone_active',
  'Bypass Active': 'tracfone_bypass_active',
  Suspended: 'tracfone_suspended',
  'Bypass Suspended': 'tracfone_bypass_suspended',
  Expired: 'tracfone_expired',
};

export const sprintSubsRequestButtonName = {
  'Show all': 'all',
  Active: 'sprint_active',
  Suspended: 'sprint_suspended',
  Expired: 'sprint_expired',
};

export const quickSubQueryObjectMap = {
  quick_active: {
    quick_status: 'active',
  },
  quick_suspended: {
    quick_status: 'suspended',
  },
  quick_expired: {
    quick_status: 'expired',
  },
};

export const quickMapCountToFilter = {
  all: ['all'],
  quick_active: ['active'],
  quick_suspended: ['suspended'],
  quick_expired: ['expired'],
};

export const quickSubsRequestButtonName = {
  'Show all': 'all',
  Active: 'quick_active',
  Suspended: 'quick_suspended',
  Expired: 'quick_expired',
};
